import { mapState } from 'vuex';
import apiClient from '@/apiClient';
import { VueGoodTable } from 'vue-good-table';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import PageLoader from '@/components/ui/PageLoader/PageLoader';
import EmailPreviewModal from '@/components/ui/modals/EmailPreviewModal/EmailPreviewModal.vue';
import ToggleButtons from '@/components/ToggleButtons/ToggleButtons.vue';
import TutorialModal from '@/components/ui/modals/TutorialModal/TutorialModal.vue';

library.add(faTrashAlt);
// trash-alt
export default {
  name: 'notifications',

  data() {
    return {
      message: '',
      footer: '',
      attachSnapshots: true,
      attachPrices: true,
      options: [
        {
          label: 'Да',
          value: true
        },
        {
          label: 'Нет',
          value: false
        }
      ],
      emailPreviewHtml: null
    };
  },

  computed: {
    ...mapState({
      text: state => state.notificationSettings.text,
      contacts: state => state.notificationSettings.contacts,
      showSketches: state => state.notificationSettings.showSketches,
      showPrices: state => state.notificationSettings.showPrices
    }),

    payload() {
      return () => {
        return Promise.all([this.$store.dispatch('loadNotificationSettings')]);
      };
    },

    settings() {
      const { message, footer, attachSnapshots, attachPrices } = this;
      return {
        text: message,
        contacts: footer,
        showSketches: attachSnapshots,
        showPrices: attachPrices
      };
    }
  },

  methods: {
    saveAndPreview() {
      const savePromise = this.$store
        .dispatch('updateNotificationSettings', this.settings)
        .then(() => {
          this.flashSuccess('Данные обновлены');
          this.$nextTick(() => {
            new Promise((resolve, reject) => {
              apiClient
                .get(`/notifications/orders/preview`)
                .then(resp => {
                  this.$refs.emailPreviewModal.open();
                  this.emailPreviewHtml = resp.data;
                })
                .catch(error => {
                  console.log(error);
                  this.$refs.emailPreviewModal.open();
                  this.flashError('Не удалось загрузить пример письма');
                  reject(error);
                });
            });
          });
        })
        .catch(() => {
          this.flashError('Произошла оштбка записи данных');
        });
      return savePromise;
    },

    pickAttachCalculations(pickedValue) {
      this.attachPrices = pickedValue;
    },

    pickAttachSnapshot(pickedValue) {
      this.attachSnapshots = pickedValue;
    }
  },

  watch: {
    text(val) {
      this.message = val;
    },
    contacts(val) {
      this.footer = val;
    },
    showPrices(val) {
      this.attachPrices = val;
    },
    showSketches(val) {
      this.attachSnapshots = val;
    }
  },

  mounted() {
    this.message = this.text;
    this.footer = this.contacts;
    this.attachPrices = this.showPrices;
    this.attachSnapshots = this.showSketches;
  },

  components: {
    PageLoader,
    VueGoodTable,
    FontAwesomeIcon,
    ToggleButtons,
    EmailPreviewModal,
    TutorialModal
  }
};
